import { render, staticRenderFns } from "./InvoiceManagement.vue?vue&type=template&id=131f7c23&scoped=true"
import script from "./InvoiceManagement.vue?vue&type=script&lang=js"
export * from "./InvoiceManagement.vue?vue&type=script&lang=js"
import style0 from "./InvoiceManagement.vue?vue&type=style&index=0&id=131f7c23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131f7c23",
  null
  
)

export default component.exports